import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    fatalError: '',
    fatalErrorCode: '',
    site: '',
    sizeUpdate: 0,
    singlePaymentMethod: false
  },
  mutations: {
    RESET_STORE: () => {
      for (const moduleName in store.state) {
        if (store.hasModule(moduleName)) {
          store.commit(moduleName + '/RESET_STORE')
        }
      }
    },
    fatalError: (state, error) => {
      state.fatalError = error
    },
    fatalErrorCode: (state, errorCode) => {
      state.fatalErrorCode = errorCode
    },
    site: (state, data) => {
      state.site = data
    },
    signalSizeUpdate: (state) => {
      state.sizeUpdate++
    },
    SET_singlePaymentMethod: (state, data) => {
      state.singlePaymentMethod = data
    }
  },
  actions: {
    setFatalError: ({commit}, error) => {
      commit('fatalError', error.description)
      commit('fatalErrorCode', error.resultCode || 'xxxxxx')
    }
  }
})

export default store
